import { useState, useEffect } from 'react'
import { useAuth } from './useAuth.jsx'
import { getAuth } from 'firebase/auth'

const API_URL = import.meta.env.VITE_API_URL || ''

export function useAdmin() {
  const { user, loading: authLoading } = useAuth()
  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function checkAdminStatus() {
      if (authLoading) return
      
      if (!user) {
        setIsAdmin(false)
        setLoading(false)
        return
      }

      try {
        const token = await getAuth().currentUser?.getIdToken()
        if (!token) {
          setIsAdmin(false)
          setLoading(false)
          return
        }

        const response = await fetch(`${API_URL}/api/admin/check`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.ok) {
          const data = await response.json()
          setIsAdmin(data.isAdmin)
        } else {
          setIsAdmin(false)
        }
      } catch (err) {
        console.error('Error checking admin status:', err)
        setError(err)
        setIsAdmin(false)
      } finally {
        setLoading(false)
      }
    }

    checkAdminStatus()
  }, [user, authLoading])

  return { isAdmin, loading: loading || authLoading, error }
}
